<div class="model-card model-card-dark">
    <div class="model-name">
        <h3>Customize your portfolio models</h3>
    </div>
    <div class="model-desc">
        Do you want to be able to create your own model based on your specific needs? <br>
        You can purchase a special subsciption that allows you to create customized models.
    </div>
    <div class="model-action"><button type="button" mat-stroked-button class="rounded-pill border-primary" color="primary" (click)="onClickPurchase()">Purchase custom portfolio access</button></div>
    <button class="card-close-btn" type="button" mat-icon-button color="primary" (click)="closeCustomPortfolioSection()"><mat-icon>close</mat-icon></button>
</div>
